import axios from 'axios'

const TICKET_URL = `${process.env.REACT_APP_API_URL}/ticket`

export type FreshDeskCreateTicketResponse = {
  freshDeskId: string
  subject: string
}

export const createGenericFreshDeskTicket = async (payload: {
  subject: string
  body: string
  requesterEmail: string
  requesterName: string
  attachments?: File[]
}) => {
  const formData = new FormData()
  formData.append('subject', payload.subject)
  formData.append('body', payload.body)
  formData.append('requesterEmail', payload.requesterEmail)
  formData.append('requesterName', payload.requesterName)

  for (const attachment of payload.attachments ?? []) {
    formData.append('attachments', attachment)
  }

  return axios.post<FreshDeskCreateTicketResponse>(`${TICKET_URL}/create`, formData)
}
